<template>
    <div class="create">
        <el-dialog title="详情" :visible.sync="dialogVisible" width="650px" :before-close="handleClose">
            <div class="main">
                <el-form :model="ruleForm" ref="ruleForm" label-width="120px" label-position="right" class="demo-ruleForm" v-loading="formload">
                    <el-form-item label="产品名称：" prop="name">
                        <p>{{ ruleForm.name }}</p>
                    </el-form-item>
                    <el-form-item label="销售价：" prop="sale_price">
                        <p>{{ ruleForm.sale_price }} 元</p>
                    </el-form-item>
                    <el-form-item label="价格上限：" prop="price_top">
                        <p>{{ ruleForm.price_top }} 元</p>
                    </el-form-item>
                    <el-form-item label="价格下限：" prop="price_bottom">
                        <p>{{ ruleForm.price_bottom }} 元</p>
                    </el-form-item>
                    <el-form-item label="URL地址：" prop="product_url">
                        <a class="link" :href="ruleForm.product_url"  target="_blank"  >{{ ruleForm.product_url }}</a>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose" type="primary" size="medium">确 认</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            formload: false,
            load: false,
            dialogVisible: false,
            ruleForm: {
                name: "",
                sale_price: "",
                price_top: "",
                price_bottom: "",
                product_url: "",
            },
        };
    },
    created() {},

    methods: {
        getDetail(row) {
            this.ruleForm = JSON.parse(JSON.stringify(row));
        },
        handleClose() {
            this.load = false;
            this.formload = false;
            this.editId = 0;
            this.ruleForm = {
                name: "",
                sale_price: "",
                price_top: "",
                price_bottom: "",
                product_url: "",
            };
            this.$refs.ruleForm.resetFields();
            this.dialogVisible = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.main {
    .demo-ruleForm {
        max-height: 420px;
        overflow-y: auto;
        &::-webkit-scrollbar-track-piece {
            background: #d3dce6;
        }

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: #99a9bf;
            border-radius: 20px;
        }
        h3 {
            margin-bottom: 20px;
            padding: 10px 0;
        }
        ::v-deep .el-form-item {
            width: 500px;
        }
    }
    .tag-group {
        padding-top: 10px;
        .el-tag {
            margin-right: 15px;
            margin-bottom: 15px;
            cursor: pointer;
            height: 34px !important;
            line-height: 34px !important;
            font-size: 14px;
        }
    }
    .el-date-editor .el-range-separator {
        width: auto !important;
    }
    .upload-demo {
        position: relative;
        .down {
            position: absolute;
            right: 180px;
            top: 0;
            .el-link {
                font-size: 12px;
                line-height: 20px;
            }
        }
    }
    .link {
        text-decoration: underline;
        color: #333;
        &:hover {
            color: #409EFF;
        }
    }
}
</style>